<button
	type="button"
	class="btn btn-xs btn-none toolbar-inner-button"
	(click)="clicked.emit()"
	[disabled]="disabled"
	[attr.aria-label]="ariaLabel"
	[matTooltip]="getTooltipText()"
	matTooltipPosition="above">
	<span class="action-icon" [ngClass]="iconClass"></span>
</button>
